import React from "react"
import { Box } from "rebass/styled-components"
import { getOffre } from "../../../utils"
const BadgeOffre = ({ node,  ...props }) => {

  return <Box variant={"triangle" + getOffre(node)} {...props} />
}
export default BadgeOffre
